(() => {
  const openBase = '.barbecue-base-open-js';
  const closeBase = '.barbecue-base-close-js';
  const baseInfo = '.barbecue-base-info-js';
  const openOption = '.barbecue-option-open-js';
  const closeOption = '.barbecue-option-close-js';
  const optionInfo = '.barbecue-option-info-js';
  const openCoupon = '.barbecue-coupon-open-js';
  const closeCoupon = '.barbecue-coupon-close-js';
  const couponInfo = '.barbecue-coupon-info-js';

  const init = () => {
    if (location.href.indexOf('customer/barbecue') < 1 ) {
      return;
    }

    $('body')
      .on('click', openBase, openBaseInfo)
      .on('click', closeBase, closeBaseInfo)
      .on('click', openOption, openOptionInfo)
      .on('click', closeOption, closeOptionInfo)
      .on('click', openCoupon, openCouponInfo)
      .on('click', closeCoupon, closeCouponInfo);
  }

  const openBaseInfo = () => {
    $(openBase).fadeOut().attr('style', 'display: none !important');
    $(closeBase).fadeIn().attr('style', 'display: block !important');
    $(baseInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeBaseInfo = () => {
    $(openBase).fadeIn().attr('style', 'display: block !important');
    $(closeBase).fadeOut().attr('style', 'display: none !important');
    $(baseInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openOptionInfo = () => {
    $(openOption).fadeOut().attr('style', 'display: none !important');
    $(closeOption).fadeIn().attr('style', 'display: block !important');
    $(optionInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeOptionInfo = () => {
    $(openOption).fadeIn().attr('style', 'display: block !important');
    $(closeOption).fadeOut().attr('style', 'display: none !important');
    $(optionInfo).fadeOut().attr('style', 'display: none !important');
  }

  const openCouponInfo = () => {
    $(openCoupon).fadeOut().attr('style', 'display: none !important');
    $(closeCoupon).fadeIn().attr('style', 'display: block !important');
    $(couponInfo).fadeIn().attr('style', 'display: block !important');
  }

  const closeCouponInfo = () => {
    $(openCoupon).fadeIn().attr('style', 'display: block !important');
    $(closeCoupon).fadeOut().attr('style', 'display: none !important');
    $(couponInfo).fadeOut().attr('style', 'display: none !important');
  }

  $(init)
})();
